// 线索助手:距离连续渐变取色 + 距离分级(供分享方块)。

export type Level = 'hit' | 'hot' | 'warm' | 'cool' | 'cold';

export function distLevel(km: number): Level {
  if (km === 0) return 'hit';
  if (km < 1000) return 'hot';
  if (km < 3000) return 'warm';
  if (km < 7000) return 'cool';
  return 'cold';
}

export function levelEmoji(l: Level): string {
  switch (l) {
    case 'hit':
      return '🟩';
    case 'hot':
      return '🟧';
    case 'warm':
      return '🟨';
    case 'cool':
      return '🟦';
    default:
      return '⬛';
  }
}

// 距离 → 连续色(近=暖,远=冷),沿做旧暖→冷色带平滑插值,让"程度"可被直观感知。
const RAMP: [number, [number, number, number]][] = [
  [0.0, [158, 59, 39]], // 很近:赭红
  [0.22, [179, 95, 44]], // 橙
  [0.45, [156, 122, 53]], // 赭黄
  [0.7, [95, 122, 90]], // 苔绿
  [1.0, [62, 96, 104]], // 很远:深青
];

export function distanceColor(km: number): string {
  const t = Math.min(Math.max(km, 0) / 15000, 1);
  for (let i = 1; i < RAMP.length; i++) {
    if (t <= RAMP[i][0]) {
      const [t0, c0] = RAMP[i - 1];
      const [t1, c1] = RAMP[i];
      const f = (t - t0) / (t1 - t0);
      const c = c0.map((v, j) => Math.round(v + (c1[j] - v) * f));
      return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
    }
  }
  return 'rgb(62, 96, 104)';
}
